// extracted by mini-css-extract-plugin
export default {"marginBtn":"NewPointForm_marginBtn__zT6Bu"};